export const EULA_STATUS = {
    ACCEPTED: 'ACCEPTED',
    DECLINED: 'DECLINED',
    NOT_APPLICABLE: 'NOT_APPLICABLE',
    UNKNOWN: null,
} as const;

export type EulaStatus = typeof EULA_STATUS[keyof typeof EULA_STATUS];

export const EULA_STATUS_OPTIONS = [
    { id: EULA_STATUS.ACCEPTED, label: 'intl-msg:eulaStatus.accepted', value: EULA_STATUS.ACCEPTED },
    { id: EULA_STATUS.DECLINED, label: 'intl-msg:eulaStatus.declined', value: EULA_STATUS.DECLINED },
    { id: EULA_STATUS.NOT_APPLICABLE, label: 'intl-msg:eulaStatus.notApplicable', value: EULA_STATUS.NOT_APPLICABLE },
    { id: 'UNKNOWN', label: 'intl-msg:eulaStatus.unknown', value: EULA_STATUS.UNKNOWN },
];
